import { render } from "./SurveyRoot.vue?vue&type=template&id=5afabdec&scoped=true"
import script from "./SurveyRoot.vue?vue&type=script&lang=ts"
export * from "./SurveyRoot.vue?vue&type=script&lang=ts"

import "./SurveyRoot.vue?vue&type=style&index=0&id=5afabdec&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5afabdec"

export default script